import React from 'react';
import { useForm } from 'react-hook-form';

const PatientSearchForm2 = ({ onSearch, isLoading, searchTerm: externalSearchTerm, searchColumn: externalSearchColumn }) => {
  const { register, handleSubmit, watch, setValue } = useForm({
    defaultValues: {
      searchTerm: externalSearchTerm || '',
      searchColumn: externalSearchColumn || 'firstName'
    }
  });

  const searchTerm = watch('searchTerm', '');
  const searchColumn = watch('searchColumn', 'firstName');

  const onSubmit = (data) => onSearch(data.searchColumn, data.searchTerm);

  const handleClear = () => {
    setValue('searchTerm', '');
    onSearch(searchColumn, '');
  };

  const handleColumnChange = (column) => {
    setValue('searchColumn', column);
    if (searchTerm.trim()) onSearch(column, searchTerm);
  };

  const searchOptions = [
    { value: 'firstName', label: 'First Name', icon: 'bi-person' },
    { value: 'lastName', label: 'Last Name', icon: 'bi-person-badge' },
    { value: 'email', label: 'Email', icon: 'bi-envelope' }
  ];

  return (
    <div className="">
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* Search Bar */}
        <div className="input-group input-group-sm mb-2">
          <span className="input-group-text bg-white">
            <i className="bi bi-search text-muted"></i>
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="Search patients..."
            {...register('searchTerm')}
          />
          {searchTerm && (
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={handleClear}
              disabled={isLoading}
            >
              <i className="bi bi-x-lg small"></i>
            </button>
          )}
          <button
            type="submit"
            className="btn btn-outline-primary"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Searching
              </>
            ) : (
              <>
                <i className="bi bi-arrow-right me-2"></i> Search
              </>
            )}
          </button>
        </div>

        {/* Search Type Buttons */}
        <div className="d-flex flex-wrap gap-2 mb-2">
          {searchOptions.map((option) => (
            <div key={option.value} className="form-check">
              <input
                type="radio"
                id={`search${option.value}`}
                className="btn-check"
                value={option.value}
                {...register('searchColumn')}
                onChange={(e) => handleColumnChange(e.target.value)}
              />
              <label
                htmlFor={`search${option.value}`}
                className={`btn btn-outline-primary btn-sm ${
                  searchColumn === option.value ? 'active text-white' : ''
                }`}
              >
                <i className={`${option.icon} me-1`}></i>
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </form>

     
    </div>
  );
};

export default PatientSearchForm2;
